export default __webpack_public_path__ + "static/media/awar14.6545beb7.jpg";